<template>
  <div class="home">
    <div class="q_body">
      <div
        class="question"
        v-for="(li, index) in lists"
        :key="index"
        @mousedown="toAnswer(li.num, index + 1)"
      >
        <div class="title">
          <div class="left">
            <img src="/tutorial/static/img/btn_question.png" class="btn_question" />
            <p>{{ li.value }}</p>
          </div>
          <img src="/tutorial/static/img/btn_open.png" class="btn_icon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  data () {
    return {
      lists: []
    }
  },
  methods: {
    toAnswer (num, position) {
      this.$store.commit('changeScroll', document.querySelector('#app').scrollTop)
      position = position.toString()
      position = ('00' + position).substr(position.length)
      this.$router.push({
        name: 'answer',
        params: {
          item: this.$route.params.item,
          answer: num,
          position:
            ('00' + this.$route.params.item).substr(
              this.$route.params.item.toString().length
            ) + position
        }
      })
    }
  },
  created () {
    let temp = {
      '1': [3, 5, 7, 9, 11, 13, 15],
      '2': [
        18,
        20,
        24,
        26,
        28,
        30,
        32,
        34,
        36,
        40,
        42,
        44,
        46,
        48,
        50,
        52,
        54,
        56
      ],
      '3': [59, 63, 65, 67, 69],
      '4': [72, 74, 76, 78, 80, 84, 86],
      '5': [89, 91, 93, 95, 97, 101, 103, 105],
      '6': [108, 111, 117, 120, 124, 126, 128, 131, 144, 146, 148],
      '7': [155, 161, 173],
      '8': [177, 179, 181, 183, 187, 189, 191]
    }
    this.lists = temp[this.$route.params.item].map(item => {
      return { num: item, value: this.$t('faq.p' + item) }
    })
  }
  // activated () {
  //   document.querySelector('#app').scrollTop = parseInt(this.$store.state.scroll)
  // },
  // deactivated () {
  //   document.querySelector('#app').scrollTop = 0
  // }
}
</script>

<style lang="scss" scoped>
.home {
  position: relative;
  width: 100%;
  .q_body {
    padding-bottom: 0.5rem;
  }
  .question {
    position: relative;
    width: 100%;
    margin-top: 0.133rem;
    cursor: pointer;
  }
  .title {
    position: relative;
    width: 100%;
    min-height: 1.333rem;
    padding: 0.1rem 0px;
    border-top: 1px solid rgba(189, 189, 189, 0.2);
    border-bottom: 1px solid rgba(189, 189, 189, 0.2);
    border-width: thin;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    -webkit-tap-highlight-color: transparent;
  }
  .title .left {
    display: flex;
    align-items: center;
  }
  .left .btn_question {
    width: 80px;
    // margin: 0px 0.147rem 0px 0.347rem;
  }
  .left p {
    display: inline-block;
    font-size: 0.4rem;
    color: #242426;
  }
  .title .btn_icon {
    width: 18px;
    margin-right: 0.467rem;
    margin-left: 8px;
    transition: all 0.5s ease;
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
  }
  .content {
    position: relative;
    padding: 0.25rem 0.8rem;
    overflow: hidden;
    height: auto;
  }
  .content p {
    color: #888888;
    font-size: 0.347rem;
    line-height: 0.5rem;
  }
}
</style>
